import React from 'react'
import { Icon, Image, Card, Grid, List, Dropdown, Header} from 'semantic-ui-react';
import Label from './../../../common/Labels'
import MomentDate from '../../../common/MomentDate';
import ImageAvater from '../../../drive/Components/ImageAvater';
import defaultImage from '../../../../images/logo/logo-128.png'
import { history } from "../../../../helpers";
import CountUp from 'react-countup';
import { dispatch } from '@rematch/core';
import LoadingComponent from '../../../common/LoadingComponent';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import 'react-dates/initialize'; // important for older versions
import 'react-dates/lib/css/_datepicker.css';
class AccountDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dateRangeOptions : [
              { key: 1, text: 'Today', value: 'today' },
              { key: 2, text: 'Last 7 Days', value: 'last_7_days' },
              { key: 3, text: 'Last 30 Days', value: 'last_30_days' },
              { key: 4, text: 'Current Month', value: 'current_month' },
              { key: 5, text: 'Custom Range', value: 'custom_range' },
            ],
            selectedRange: 'current_month',
            selectedWorkspace: "all",
            customRange: [null, null],
            focusedInput: null,
            loading: false,
            isMounted: false,
            consumptionDetailsChart:{}
          }
    }
    handleCustomRangeSubmit = () => {
        const [startDate, endDate] = this.state.customRange;
        if (!startDate || !endDate) return;
        const start = new Date(startDate);
        const end = new Date(endDate);
        const formatDate = (date) => date.toISOString().split("T")[0];
        const payload = {
          from_date: formatDate(new Date(Date.UTC(start.getFullYear(), start.getMonth(), start.getDate()))),
          to_date: formatDate(new Date(Date.UTC(end.getFullYear(), end.getMonth(), end.getDate()))),
          accountId: this.props.match.params.accountId,
        };
        if (this.state.selectedWorkspace && this.state.selectedWorkspace !== "all") {
          payload.selectedOrganizationId = this.state.selectedWorkspace;
        }
        dispatch.account.getConsumptionDetails(payload);
    };
    componentDidUpdate = (nextProps) => {
      if(this.props.consumptionDetails !== nextProps.consumptionDetails) {
        const consumptionDetailsChart = {
          playbooksCreated: this.props.consumptionDetails.filter(
            item => item.data.event === 'PlaybookCreated'
          ),
          playbooksGenerated: this.props.consumptionDetails.filter(
            item => item.data.event === 'PlaybookComplete'
          ),
          activitiesGenerated: this.props.consumptionDetails.filter(
            item => item.data.event === 'PlaybookComplete'
          ),
          playbooksPublished: this.props.consumptionDetails.filter(
            item => item.data.event === 'PlaybookPublished'
          ),
          playbookExported: this.props.consumptionDetails.filter(
            item => item.data.event === 'PlaybookExported'
          ),
          linksGenerated: this.props.consumptionDetails.filter(
            item => item.data.event === 'ActivityDetailsGenerated'
          ),  
          initiativeCreated: this.props.consumptionDetails.filter(
            item => item.data.event === 'InitiativeCreated'
          ),
          teamsCreated: this.props.consumptionDetails.filter(
            item => item.data.event === 'TeamCreated'
          ),
          scenarioExecution: this.props.consumptionDetails.filter(
            item => item.data.event === 'ScenarioExecution'
          )
        };
        this.setState({ consumptionDetailsChart });
      }
    }
    handleDatesChange = ({ startDate, endDate }) => {
        this.setState({ customRange: [startDate, endDate] });
    };
    handleFocusChange = (focusedInput) => {
        this.setState({ focusedInput });
    };
    handleWorkspaceChange = (e, { value }) => {
        this.setState({ selectedWorkspace: value });
        const now = new Date();
        let from, to;
    
        const formatDate = (date) => date.toISOString().split("T")[0];
    
        switch (this.state.selectedRange) {
          case "today":
            from = to = formatDate(now);
            break;
          case "last_7_days":
            to = formatDate(now);
            from = formatDate(new Date(now.setDate(now.getDate() - 6)));
            break;
          case "last_30_days":
            to = formatDate(now);
            from = formatDate(new Date(now.setDate(now.getDate() - 29)));
            break;
          case "current_month":
            from = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
            to = formatDate(new Date());
            break;
          case "custom_range":
            from = formatDate(this.state.customRange[0]);
            to = formatDate(this.state.customRange[1]);
            return;
          default:
            return;
        }
        let payload = {
          from_date: from,
          to_date: to,
          selectedAccountId: this.props.match.params.accountId,
        };
        if( value && value !== "all") {
          payload.selectedOrganizationId = value;
        }
        dispatch.account.getConsumptionDetails(payload);
    };
    handleDateRangeChange = (e, { value }) => {
        const now = new Date();
        let from, to;
    
        const formatDate = (date) => date.toISOString().split("T")[0];
    
        switch (value) {
          case "today":
            from = to = formatDate(now);
            break;
          case "last_7_days":
            to = formatDate(now);
            from = formatDate(new Date(now.setDate(now.getDate() - 6)));
            break;
          case "last_30_days":
            to = formatDate(now);
            from = formatDate(new Date(now.setDate(now.getDate() - 29)));
            break;
          case "current_month":
            from = formatDate(new Date(now.getFullYear(), now.getMonth(), 1));
            to = formatDate(new Date());
            break;
          case "custom_range":
            this.setState({ selectedRange: value });
            return;
          default:
            return;
        }
    
        this.setState({ selectedRange: value });
    
        const payload = {
          from_date: from,
          to_date: to,
          selectedAccountId: this.props.match.params.accountId,
        };
        if (this.state.selectedWorkspace && this.state.selectedWorkspace !== "all") {
          payload.selectedOrganizationId = this.state.selectedWorkspace;
        }
        dispatch.account.getConsumptionDetails(payload);
      };
      async componentDidMount() {
        this.setState({ loading: true, isMounted: true });
        const now = new Date();
          const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
          const formatDate = (date) => date.toISOString().split("T")[0];
          const from = formatDate(firstDay);
          const to = formatDate(now);
        //   let orgPayload = {
        //         selectedAccountId: this.props.match.params.accountId,
        //     }
        //    await dispatch.account.getAllAcountUserWorkspaces(orgPayload);
          let payload = {
            from_date: from,
            to_date: to,
            selectedAccountId: this.props.match.params.accountId,
          };
          await dispatch.account.getConsumptionDetails(payload);
          const {consumptionDetails} = this.props;
          this.setState({
            loading: false,
            isMounted: false,
            mountedConsumptionDetails: consumptionDetails,
          });
      }
    goBack() {
        history.push('/app/platform/home')
    }

    render() {
        const { accountDetail } = this.props;
        const {mountedConsumptionDetails} = this.state
        let phone = accountDetail.phone && accountDetail.phone.length > 6 ? accountDetail.phone : "NA";
        let businessDomain = accountDetail.businessDomain ? accountDetail.businessDomain : "NA";

        let intList =accountDetail.integrations &&  accountDetail.integrations.filter(
            (item) => item.isActive
          );
        let int = intList && intList.map((m) => {
            return <img src={m.id.image} className="scaleDown integrations-icons" style={{ margin: "0 3px 0 0px" }} />
        })
        let orgList =
          mountedConsumptionDetails &&
            Array.from(
              new Map(
                mountedConsumptionDetails.map((org) => [
                  org.organization._id,
                  {
                    key: org.organization._id,
                    text: org.organization.name,
                    value: org.organization._id,
                  },
                ])
              ).values()
            ) || [];
            orgList.unshift({
              key: "all",
              text: "All Workspaces",
              value: "all",
            });
            orgList = orgList.filter((item) => item.key && item.value);
        return (
            <div className="general-setting pad_20">
                <LoadingComponent active={this.props.loadingConsumptions || this.state.loading} message={"Loading Consumption Details"}/>
                <Card>
                    <Card.Header>
                        <Icon name="arrow left" onClick={() => this.goBack()} />
                        Account Details
                        </Card.Header>
                    <Card.Content className="pad_0">
                        <Grid columns="equal">
                            <Grid.Row>
                                <Grid.Column>
                                    <Label name="Logo" text={<Image src={accountDetail.logo ? accountDetail.logo : defaultImage} style={{ height: "75px", boxShadow: "0 1px 3px 0 #d4d4d5, 0 0 0 1px #d4d4d5", padding: "5px" }} />} />
                                </Grid.Column>
                                <Grid.Column>
                                    <Label name=" Name" text={accountDetail.name} /><br />
                                    <Label name="Phone" text={phone} /> <br />
                                </Grid.Column>
                                <Grid.Column>
                                    <Label name="Subscription" text={accountDetail.planDisplayName} /> <br />
                                    <Label name="Account Id" text={accountDetail.customerId} />
                                </Grid.Column>
                                <Grid.Column>
                                    <Label name="Billing Period" text={accountDetail.planId.includes("annual") ? "Year" : "Month"} /> <br />
                                    <Label name="Creation Date" text={<MomentDate date={accountDetail.createdAt} />} /><br />
                                </Grid.Column>
                                <Grid.Column >
                                    <Label name="Domain" text={businessDomain} /> <br />
                                    <Label name="Integrations" text={int} />
                                </Grid.Column>
                            </Grid.Row>

                        </Grid>
                    </Card.Content>
                </Card>
                <Card>
                    <Card.Header>Consumption Details</Card.Header>
                    <Card.Content style={{ padding: "10px" }}>
                        <div>
                                    <div
                                      style={{
                                        display: "flex",
                                        gap: "1em",
                                        marginBottom: "1em",
                                        alignItems: "center",
                                      }}
                                    >
                                      <label style={{ marginRight: "5px" }}>
                                        <strong>Workspace</strong>
                                      </label>
                                      <Dropdown
                                        placeholder="Select Range"
                                        selection
                                        options={orgList}
                                        value={this.state.selectedWorkspace}
                                        onChange={this.handleWorkspaceChange}
                                      />
                                      <label style={{ marginRight: "5px" }}>
                                        <strong>Date Range</strong>
                                      </label>
                                      <Dropdown
                                        placeholder="Select Range"
                                        selection
                                        options={this.state.dateRangeOptions}
                                        value={this.state.selectedRange}
                                        onChange={this.handleDateRangeChange}
                                      />
                                      {this.state.selectedRange === "custom_range" && (
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <label style={{ marginRight: "0.5em", display: "block" }}>
                                            <strong>Select Date Range</strong>
                                          </label>
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "row",
                                              gap: "0.75em",
                                              height: "fit-content",
                                              alignItems: "center",
                                            }}
                                          >
                                            <div className="ui input" style={{ position: 'relative' }}>
                                              {!(this.state.customRange && (this.state.customRange[0] || this.state.customRange[1])) &&
                                              <i
                                                className="calendar icon"
                                                style={{
                                                  position: 'absolute',
                                                  right: 10,
                                                  top: '45%',
                                                  transform: 'translateY(-45%)',
                                                  zIndex: 1,
                                                  color: '#888',
                                                  pointerEvents: 'none',
                                                }}
                                              />
                                              }
                                              <div style={{ paddingLeft: 30 }}>
                                                <DateRangePicker
                                                  startDate={this.state.customRange && this.state.customRange[0] || null}
                                                  endDate={this.state.customRange && this.state.customRange[1] || null}
                                                  onDatesChange={this.handleDatesChange}
                                                  focusedInput={this.state.focusedInput}
                                                  onFocusChange={this.handleFocusChange}
                                                  isOutsideRange={(day) => day.isAfter(moment())}
                                                  showClearDates={true}
                                                  startDatePlaceholderText="From Date"
                                                  endDatePlaceholderText="To Date"
                                                  displayFormat="YYYY-MM-DD"
                                                  numberOfMonths={2}
                                                />
                                              </div>
                                            </div>
                        
                                            <button
                                              className="ui button primary"
                                              disabled={
                                                !this.state.customRange || !this.state.customRange[0] || !this.state.customRange[1]
                                              }
                                              onClick={this.handleCustomRangeSubmit}
                                              style={{marginBottom:"4px", marginTop:"4px"}}
                                            >
                                              Apply
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                        <Header as="h5">All Workspaces - {this.state.dateRangeOptions.find(opt=> opt.value === this.state.selectedRange).text}</Header>
                        <Grid columns="equal" celled='internally' className="count-block-item setHoverEffect" style={{ margin: "20px 0px 0px 0px", border:"1px solid #d4d4d5", borderRadius:"5px"}} >
                            <Grid.Row>
                                <Grid.Column>
                                        <CountUp end={this.props.playbooksCreated} duration={5} />
                                    <label>Total Playbooks generated With AI</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.props.activitiesGenerated} duration={5} />
                                    <label>Total Activities generated</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.props.linksGenerated} duration={5} />
                                    <label>Total Links Researched</label>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.playbooksCreated ? this.state.consumptionDetailsChart.playbooksCreated.length : 0} duration={5} />
                                    <label>Total Playbooks Created Step By Step</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.playbooksPublished ? this.state.consumptionDetailsChart.playbooksPublished.length : 0} duration={5} />
                                    <label>Total Playbooks Published</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.initiativeCreated ? this.state.consumptionDetailsChart.initiativeCreated.length : 0} duration={5} />
                                    <label>Total Projects/Initiatives Created</label>
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.playbookExported ? this.state.consumptionDetailsChart.playbookExported.length : 0} duration={5} />
                                    <label>Total Playbooks Exported</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.teamsCreated ? this.state.consumptionDetailsChart.teamsCreated.length : 0} duration={5} />
                                    <label>Total Teams Created</label>
                                </Grid.Column>
                                <Grid.Column>
                                        <CountUp end={this.state.consumptionDetailsChart.scenarioExecution ? this.state.consumptionDetailsChart.scenarioExecution.length : 0} duration={5} />
                                    <label>Total Make Scenarios Executed</label>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid >
                    </Card.Content>
                </Card>
                <Card>
                    <Card.Header>Account Owner / Billing Admin ({accountDetail && accountDetail.users && accountDetail.users.length})</Card.Header>
                    <Card.Content className="pad_0">
                        <Grid columns="equal">
                            {accountDetail && accountDetail.users && accountDetail.users.map((item, i) => {

                                return (
                                    <Grid.Row style={{ paddingBottom: 0 }} key={i}>
                                        <Grid.Column>
                                            <List horizontal >
                                                <List.Item className="w_100">
                                                    <ImageAvater imageStyle="w_32 h_32" user={item && item.id && item.id} />
                                                    <b className="f_12">{item && item.id && item.id.firstName} {item && item.id && item.id.lastName}</b><br />
                                                    <span className="f_10">
                                                        {item && item.id && item.role === "customerAdmin" ? "Account Owner" :
                                                            item && item.id && item.role === "user" ? "Account User" : null}
                                                    </span>
                                                </List.Item>
                                            </List>
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Label name="Email" text={item && item.id && item.id.email} />
                                        </Grid.Column>
                                        <Grid.Column>
                                            <Label name="Status" text={item && item.id && item.id.isDeactivated ? <span className="clr-red">In Active</span> : <span className="clr-green" >Active</span>} />
                                        </Grid.Column>

                                    </Grid.Row>
                                )
                            })}

                        </Grid>
                    </Card.Content>
                </Card>
            </div >
        )
    }
}

export default AccountDetails;